<template>
  <div>
    <DataTable
        class="mt-5"
        :loading="isLoading"
        :value="currentTabState.tableData"
        :paginator="true"
        :rows="currentTabState.rowsPerPage"
        :totalRecords="currentTabState.totalRecords"
        :sortField="currentTabState.sortField"
        :sortOrder="currentTabState.sortOrder"
        :rowGroupMode="rowGroupMode"
        :groupRowsBy="groupRowsBy"
        selectionMode="single"
        @row-select="onRowSelect"
        @row-click="onRowClick"
        @page="onPageChange"
        @sort="onSort"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="$rowsPerPageOptions"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        :lazy="true"
        :rowClass="certificateRowClass"
    >
      <!-- Standard columns -->
      <Column
          v-for="col in columns"
          :key="col.field"
          :field="col.field"
          :header="col.header"
          :sortable="col.sortable"
          :headerStyle="{ width: col.width }">
        <!-- Custom slot content within Column if needed -->
        <template v-if="col.custom" #body="slotProps">
          <slot :name="col.slotName" :rowData="slotProps.data"/>
        </template>
      </Column>
      <template #empty>
        No records found.
      </template>
    </DataTable>

    <!-- Status legend for the coloured bar at the start of each row -->
    <div class="flex items-center justify-end mt-2 text-xs text-gray-600">
      <span class="inline-block w-3 h-3 mr-1 rounded-sm status-bar-new"></span>
      <span class="mr-4">New</span>
      <span class="inline-block w-3 h-3 mr-1 rounded-sm status-bar-completed"></span>
      <span>Completed</span>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex";

export default {
  props: {
    columns: {
      type: Array,
      required: true,
    },
    rowGroupMode: {
      type: String,
      default: null
    },
    groupRowsBy: {
      type: String,
      default: null
    },
    enableRowClick: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    ...mapState("certificate", {
      currentTabState: state => state.tabs[state.currentTab],
      isLoading: state => state.isLoading,
    }),
  },
  methods: {
    ...mapActions("certificate", ["updateTableSettings", "updateSortOptions"]),

    onRowSelect(event) {
      this.$emit("row-select", event);
    },
    onRowClick(event) {
      if (this.enableRowClick) {
        this.$emit("row-click", event);
      }
    },
    onPageChange(event) {
      this.updateTableSettings({
        rows: event.rows,
        page: event.page, // This is 0-based in the event
      });
    },
    onSort(event) {
      this.updateSortOptions({
        field: event.sortField,
        order: event.sortOrder,
      });
    },

    // Grey bar for a New certificate, green once it is Completed
    certificateRowClass(rowData) {
      return rowData && rowData.status === "Completed" ? "row-certificate-completed" : "row-certificate-new";
    },
  },
};
</script>

<style scoped>
.status-bar-new {
  background-color: #a0aec0;
}
.status-bar-completed {
  background-color: #48bb78;
}
::v-deep .row-certificate-new > td:first-child {
  border-left: 5px solid #a0aec0 !important;
}
::v-deep .row-certificate-completed > td:first-child {
  border-left: 5px solid #48bb78 !important;
}
</style>
